import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Button } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import {
  Link,
  //  useLocation
} from 'react-router-dom'
import { Alert, AlertTitle } from '@material-ui/lab'
import PublicCourseHeader from './PublicCourseHeader'
import styles from './PublicCourse.module.css'
import PublicCourseCard from './PublicCourseCard'
import {
  selectorPublicCoursesGroup, getCoursesGroup,
  selectorProfessionalCourseGroup, getProfessionalCoursesGroup,
  getPublicCoursesStatus, selectorPublicCoursesStatus,
} from '../../../app/slices/courseSlice'

const useStyles = makeStyles({
  root: {
  },
  surveyBtn: {
    backgroundColor: '#f39994',
    width: '15%',
    height: '37px',
    borderRadius: '20px',
    color: '#ffffff',
    textAlign: 'center',
    fontWeight: '600',
    display: 'flex',
    margin: '0 auto',
    justifyContent: 'center',
    alignItems: 'center',
    '&:hover': {
      backgroundColor: '#e6332a',
      boxShadow: '0 2px 6px 0 rgba(197, 0, 0, 0.36)',
      color: '#ffffff',
    },
    '@media (max-width: 960px)': {
      width: '25% !important',
    },
    '@media (max-width: 600px)': {
      width: '35% !important',
    },
  },
  certificateBtn: {
    backgroundColor: '#f39994',
    width: '23%',
    height: '37px',
    borderRadius: '20px',
    color: '#ffffff',
    textAlign: 'center',
    fontWeight: '600',
    display: 'flex',
    margin: '15px auto',
    justifyContent: 'center',
    alignItems: 'center',
    '&:hover': {
      backgroundColor: '#e6332a',
      boxShadow: '0 2px 6px 0 rgba(197, 0, 0, 0.36)',
      color: '#ffffff',
    },
    '@media (max-width: 960px)': {
      width: '30% !important',
    },
    '@media (max-width: 600px)': {
      width: '50% !important',
    },
  },
})

const PublicCourse = ({ bought }) => {
  const classes = useStyles()
  const cources = useSelector(selectorPublicCoursesGroup)
  const professionalCources = useSelector(selectorProfessionalCourseGroup)
    ?.filter((course) => course?.status !== 100)
  const publicCoursesStatus = useSelector(selectorPublicCoursesStatus)
  const dispatch = useDispatch()
  const role = useSelector((state) => state.user?.role)
  // const { pathname } = useLocation()

  useEffect(() => {
    dispatch(getPublicCoursesStatus())

    //     if ([2, 3].includes(role?.roleId)) {
    //   dispatch(getAllPackages())
    // }

    if (!bought) {
      dispatch(getCoursesGroup())
    }
    if (bought) {
      dispatch(getProfessionalCoursesGroup())
    }
  }, [])

  // const latestCourse = cources?.[cources?.length - 1]

  if (bought) {
    return (

      <div className={styles.main}>
        {professionalCources?.length ? professionalCources?.map((item) => {
          const courseId = item?.id
          const userExamId = item?.userExamId
          const courseGroupId = item?.id

          const route = ['course', courseId].join('/')
          const routeSurvey = ['course', 'survey', userExamId].join('/')
          const routeCertificate = ['certificate', courseGroupId].join('/')

          return (
            <>
              <Link to={route}>
                <PublicCourseCard course={item} />
                {/* <PublicCourseHeader expireDate={cources?.[0]?.expireDate
      ? cources?.[0]?.expireDate : null}
    /> */}
              </Link>
              {item?.status === 104 && (
              <Link
                to={routeSurvey}
                className={classes.surveyBtn}
              >
                شرکت در آزمون
              </Link>
              )}
              {item?.status === 105 && (
              <Link
                to={routeCertificate}
                className={classes.certificateBtn}
              >
                درخواست گواهی نامه
              </Link>
              )}
            </>
          )
        })
        // <p>شما هیچ دوره خریداری شده ای ندارید</p>
          : (
            <Alert
              style={{
                padding: '0 !important',
                width: '100% !important',
                display: 'flex',
              }}
              severity="warning"
            >
              <AlertTitle style={{ padding: '0 !important' }}>توجه</AlertTitle>
              شما هیچ دوره خریداری شده ای ندارید
            </Alert>
          )}
      </div>
    )
  }

  return (
    <div className={styles.main}>
      {[1].includes(role?.roleId) && <PublicCourseHeader />}
      {cources?.map((item) => {
        const courseId = item?.id
        const userExamId = item?.userExamId

        const route = ['course', courseId].join('/')
        const routeSurvey = ['course', 'survey', userExamId].join('/')

        return (
          <>
            <Link
            // to={(item?.status === 10 || item?.status === 101) ? pathname : route}
              to={route}
            >
              <PublicCourseCard course={item} />
            </Link>
            {item?.status === 104 && (
            <Link to={routeSurvey} className={classes.surveyBtn}>
              فرم نظرسنجی
            </Link>
            )}
          </>
        )
      })}
      {/* <Button className={classes.surveyBtn}>
        فرم نظرسنجی
      </Button>
      <br /> */}
      {publicCoursesStatus?.data?.status === 105 && (
      <Button
        className={classes.certificateBtn}
      >
        درخواست گواهی نامه
      </Button>
      )}
    </div>
  )
}

export default React.memo(PublicCourse)
